import React from 'react'
import localization from '../lib/localization/localization'

export default function Thermostat({ui_element_id, param_value, units, ui_element_svg_id, clickPlus, clickMinus, ui_language}){
    
    let thermostat_data = (
        <div className="thermostat">
            <div className="thermostat_line">
                <div className="thermostat_comf_temp">{param_value.comf_temp}</div>
                <div className="thermostat_plus" onClick={()=> clickPlus(ui_element_id)}> + </div>
            </div>
            <div className="thermostat_line">
                <div className="thermostat_curr_temp">{param_value.curr_temp}{units}</div>
                <div className="thermostat_minus" onClick={()=> clickMinus(ui_element_id)}> - </div>
            </div>
        </div>
    )

    let thermostat_data_off = (
        <div className="thermostat">
            <div className="thermostat_line">
                <div className="thermostat_comf_temp_off">{localization.localize(ui_language).off}</div>
                <div className="thermostat_plus" onClick={()=> clickPlus(ui_element_id)}> + </div>
            </div>
            <div className="thermostat_line">
                <div className="thermostat_curr_temp">{param_value.curr_temp}{units}</div>
                <div className="thermostat_minus" onClick={()=> clickMinus(ui_element_id)}> - </div>
            </div>
        </div>
    )

    if (param_value.mode !== "1") return thermostat_data
    else return thermostat_data_off

    
}